import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 1090. 支払タスクファイル削除
 * [DELETE] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/payment_tasks/:task_id/payment_task_documents/:id
 */
type Props = {
  identifier: string;
  team_id: number;
  purchase_order_id: number;
  task_id: number;
  id: number;
};

const destroyPaymentTaskDocument = (props: Props): Promise<any> => {
  return axios.delete(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.purchase_order_id}/payment_tasks/${props.task_id}/payment_task_documents/${props.id}`
  );
};

export const useDestroyPaymentTaskDocument = () => {
  return useMutation({
    mutationFn: destroyPaymentTaskDocument,
  });
};
